define('lib/Podio.UI.Reminder',['require','underscore','jquery','moment','lib/jquery/jquery.podioDropdown','translate','lib/Podio.Transport.Reminder','lib/Podio.UI.Tooltips','lib/Podio.UI.SettingsBalloon'],function (require) {

  var _ = require('underscore');
  var $ = require('jquery');
  var moment = require('moment');
  require('lib/jquery/jquery.podioDropdown');
  var t = require('translate');

  var ReminderTransport = require('lib/Podio.Transport.Reminder');
  var Tooltips = require('lib/Podio.UI.Tooltips');
  var settingsBalloon = require('lib/Podio.UI.SettingsBalloon');

  var defaultOptions = {
    txtDisabled: t('This task needs a due date before it can have a reminder. #reminders'),
    txtDateInPast: t('Due date is in the past and reminder will not be sent. #reminders'),
    txtDateFutureWarning: t('Due date must be in the future to set a reminder. #reminders')
  };
  var options;

  var PodioReminder = function(elmAnchor, valueFieldExpression, givenOptions) {
    var _elmAnchor = elmAnchor;
    var _valueFieldExpression = valueFieldExpression;
    var _elmBalloon, elmDeltaSelect, elmSummary, elmRemindText, elmPastDateWarning;

    options = givenOptions ? _.defaults(givenOptions, defaultOptions) : defaultOptions;
    var currentDateTime = options.currentDateTime;
    var elmReminderEnabled = options.elmReminderEnabled;

    function init() {
      settingsBalloon.signals.onInitialized.add(helpers.setupReminderForm);
      settingsBalloon.signals.onShow.add(handlers.onShow);
      settingsBalloon.signals.onApply.add(handlers.onApply);
      settingsBalloon.signals.onRemove.add(handlers.onRemove);
    }

    function dispose() {
      settingsBalloon.signals.onInitialized.remove(helpers.setupReminderForm);
      settingsBalloon.signals.onShow.remove(handlers.onShow);
      settingsBalloon.signals.onApply.remove(handlers.onApply);
      settingsBalloon.signals.onRemove.remove(handlers.onRemove);

      if(_elmAnchor) {
        settingsBalloon.destroy(_elmAnchor);
      }
    }

    var helpers = {
      setupReminderForm: function(elmAnchor, elmBalloon) {
        if(_elmAnchor[0] == elmAnchor[0]) {
          _elmBalloon = elmBalloon;
          elmDeltaSelect = elmBalloon.find('.remind_delta');
          elmDeltaSelect.podioDropdown({
            maxDropHeight: 140
          });
          elmDeltaSelect.bind('change.dropdown.podio', handlers.onDeltaChanged);

          elmSummary = elmBalloon.find('.summary');
          elmRemindText = elmBalloon.find('.highlighted');
          elmPastDateWarning = elmBalloon.find('.past-date-warning');

          if(_.isDate(currentDateTime)) {
            helpers.updateTextSummary();
            helpers.showHidePastWarning();
          } else {
            elmSummary.hide();
          }
        }
      },

      getReminderDateTime: function() {
        if(_.isDate(currentDateTime) && (elmDeltaSelect || (elmAnchor && elmAnchor.data('remind-delta')))) {
          var deltaStr = elmDeltaSelect ? elmDeltaSelect.val() : elmAnchor.data('remind-delta');
          if(deltaStr && deltaStr !== '') {
            var delta = parseInt(deltaStr, 10);
            var deltaInMs = delta * 60 * 1000; // Delta is in minutes
            var reminderDateTime = new Date(currentDateTime - deltaInMs);
            return reminderDateTime;
          } else {
            return null;
          }
        } else {
          return null;
        }
      },

      updateTextSummary: function() {
        if(elmSummary) {
          var reminderDateTime = helpers.getReminderDateTime();
          if(_.isDate(reminderDateTime) && elmRemindText) {
            var summary = moment(reminderDateTime).format('LLLL');
            elmRemindText.text(summary);
            elmSummary.show();
          } else {
            elmSummary.hide();
          }
        }
      },

      updateAnchorState: function() {
        if (_elmAnchor) {
          _elmAnchor.removeClass('disabled').removeClass('unset').removeClass('set').removeClass('wontfire');
          var dateNow = new Date();
          if (_.isDate(currentDateTime)) {
            var remindDelta = _elmAnchor.data('remindDelta') > -1 ? _elmAnchor.data('remindDelta').toString() : null;
            if (remindDelta && remindDelta !== '' && (!elmReminderEnabled || elmReminderEnabled.val() == 'true')) {
              _elmAnchor.addClass('set');
              var reminderDateTime = helpers.getReminderDateTime();
              _elmAnchor.attr('title', moment(new Date(currentDateTime - (remindDelta * 60 * 1000))).format('LLLL'));

              if (currentDateTime < dateNow) {
                helpers.disable();
                _elmAnchor.addClass('wontfire');
                _elmAnchor.attr('title', options.txtDateInPast);
              }
            } else {
              if (currentDateTime < dateNow) {
                helpers.disable();
                _elmAnchor.addClass('unset');
                elmAnchor.attr('title', options.txtDateFutureWarning);
              }
              else {
                _elmAnchor.addClass('unset');
                _elmAnchor.attr('title', t('Remind me. #reminders'));
              }
            }
          } else {
            helpers.disable();
          }
        }
      },

      disable: function() {
        if(_elmAnchor) {
          _elmAnchor.removeClass('disabled').removeClass('unset').removeClass('set');
          _elmAnchor.addClass('disabled');
          _elmAnchor.attr('title', options.txtDisabled);
        }
      },

      reset: function() {
        currentDateTime = null;
        helpers.updateAnchorState();
        if(_elmAnchor && _elmBalloon) {
          settingsBalloon.clear(_elmAnchor, _elmBalloon);
          if(elmDeltaSelect) {
            elmDeltaSelect.trigger("refresh.dropdown.podio");
          }
        }

        if(elmReminderEnabled) {
          elmReminderEnabled.val('false');
        }
      },

      showHidePastWarning: function() {
        var reminderDateTime = helpers.getReminderDateTime();
        if(_.isDate(reminderDateTime) && elmPastDateWarning) {
          if(reminderDateTime < new Date()) {
            elmPastDateWarning.show();
          } else {
            elmPastDateWarning.hide();
          }
        }
      }
    };

    var handlers = {
      onShow: function(elmAnchor, elmBalloon) {
        if(_elmAnchor[0] == elmAnchor[0]) {
          Tooltips.hideAll();
          if(elmDeltaSelect) {
            if (elmAnchor.data('remind-delta')) {
              elmDeltaSelect.val(elmAnchor.data('remind-delta').toString());
            }
            else {
              if(currentDateTime && currentDateTime.getHours() === 23 && currentDateTime.getMinutes() === 59 && currentDateTime.getSeconds() === 59) {
                elmDeltaSelect.val('360'); // We have the default time of 23:59:59, set to 6 hours before rather than on date by default
              } else {
                elmDeltaSelect.val('0');
              }
            }

            elmDeltaSelect.trigger("refresh.dropdown.podio");
            helpers.updateTextSummary();
            helpers.showHidePastWarning();
          }
        }
      },

      onApply: function(elmAnchor, elmBalloon) {
        if(_elmAnchor[0] == elmAnchor[0]) {
          $(_valueFieldExpression).val(elmDeltaSelect.val());
          elmAnchor.data('remind-delta', elmDeltaSelect.val());

          if(elmReminderEnabled) {
            elmReminderEnabled.val('true');
          }

          helpers.updateAnchorState();
          if (elmAnchor.data('ref-id')) {
            ReminderTransport.update(elmAnchor.data('ref-type'), elmAnchor.data('ref-id'), elmDeltaSelect.val());
          }
        }
      },

      onDateTimeChanged: function(newDateTime) {
        currentDateTime = newDateTime;
        if(_.isDate(currentDateTime)) {
          helpers.updateTextSummary();
          helpers.showHidePastWarning();
        } else {
          settingsBalloon.hideAll();
          if(_elmAnchor && _elmBalloon) {
            settingsBalloon.clear(_elmAnchor, _elmBalloon);
          }
        }
        helpers.updateAnchorState();
      },

      onDeltaChanged: function() {
        helpers.updateTextSummary();
        helpers.showHidePastWarning();
      },

      onRemove: function(elmAnchor, elmBalloon) {
        if(_elmAnchor[0] == elmAnchor[0]) {
          $(_valueFieldExpression).val('');
          elmAnchor.data('remind-delta', '');

          if(elmReminderEnabled) {
            elmReminderEnabled.val('false');
          }

          helpers.updateAnchorState();
          if (elmAnchor.data('ref-id')) {
            ReminderTransport.destroy(elmAnchor.data('ref-type'), elmAnchor.data('ref-id'));
          }
        }
      }
    };

    return {
      init: init,
      dispose: dispose,
      dateTimeChanged: handlers.onDateTimeChanged,
      disable: helpers.disable,
      updateAnchorState: helpers.updateAnchorState,
      reset: helpers.reset
    };

  };

  function init(elmAnchor, valueFieldExpression, options) {
    var reminder = new PodioReminder(elmAnchor, valueFieldExpression, options);
        reminder.init();

    return reminder;
  }

  return {
    init: init
  };

});


